import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout, { Card, Label, Badge, Spinner } from "../components/Layout";
import { Bell, Check } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/notifications");
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  const checkDeadlines = async () => {
    const { data } = await api.post("/tasks/check-deadlines");
    alert(`Generate ${data.notifications_created} nuove notifiche di scadenza.`);
    load();
  };

  return (
    <Layout
      title="Notifiche"
      subtitle="Eventi recenti, scadenze e segnalazioni del sistema"
      actions={<button onClick={checkDeadlines} className="btn-secondary" data-testid="btn-check-deadlines">Esegui check scadenze</button>}
    >
      {loading ? <Spinner /> : items.length === 0 ? (
        <Card><div className="text-sm text-zinc-500 py-8 text-center">Nessuna notifica</div></Card>
      ) : (
        <Card className="p-0 overflow-hidden" data-testid="notif-list">
          {items.map((n) => (
            <div key={n.id} className={`border-b border-zinc-100 px-4 py-3 flex items-center gap-3 hover:bg-zinc-50 transition-colors ${!n.read_at ? "bg-blue-50/30" : ""}`} data-testid={`notif-${n.id}`}>
              <Bell weight={n.read_at ? "regular" : "fill"} className={n.read_at ? "text-zinc-300" : "text-klein"} size={18} />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium">{n.title}</div>
                <div className="text-xs text-zinc-500 mt-0.5">{n.kind} • {new Date(n.created_at).toLocaleString("it-IT")}</div>
              </div>
              {n.payload?.tender_id && (
                <button onClick={() => nav(`/tenders/${n.payload.tender_id}`)} className="btn-ghost text-xs">Apri gara</button>
              )}
              {!n.read_at && (
                <button onClick={() => markRead(n.id)} className="btn-ghost text-xs" data-testid={`mark-read-${n.id}`}>
                  <Check size={12} className="inline mr-1" /> Letta
                </button>
              )}
            </div>
          ))}
        </Card>
      )}
    </Layout>
  );
}
